import axios from "axios";
import { IChat, IConversation } from "../../types/chatbot";
import { ChatHistory } from "../../Controller/request";
import { nanoid } from "nanoid";

export const fetchChats = async (): Promise<IChat[]> => {

    try {
        const chatHistoryResponse = await ChatHistory();
        const chatApiResponse = chatHistoryResponse?.data?.chatHistory;

        // Grouping conversations by sessionId
        const chatMap: { [key: string]: IChat } = {};

        chatApiResponse.forEach((chat: any) => {
            // Checking for old sessionId || creating new sessionId
            const chatId = chat.chat_id || nanoid();

            // If the sessionId does not exist in chatMap, create a new sessionId
            if (!chatMap[chatId]) {
                chatMap[chatId] = {
                    sessionId: chatId,
                    title: "New chat",
                    conversations: [],
                };
            }

            const conversation: IConversation = {
                query: chat?.user_query,
                result: chat?.bot_response,
                resultId: chat.id || null,
                isLiked: undefined,
                resultDocument: chat.resultDocument || [],
                raw: {
                    answer: chat?.bot_response,
                    document_urls: chat.resultDocument || [],
                },
                locale: chat.locale || "en-US",
                isLoading: false,
            };

            // Add the conversation to the corresponding sessionId entry in chatMap
            chatMap[chatId].conversations.push(conversation);
        });

        // Converting the chatMap to an array of IChat objects
        const formattedChats: IChat[] = Object.values(chatMap);
        sessionStorage.setItem('LastResponseId', chatApiResponse[chatApiResponse.length - 1]?.id || null);

        const newChat: IChat = {
            sessionId: nanoid(),
            title: "New Chat",
            conversations: [],
        };
        formattedChats.push(newChat);

        return formattedChats;
    } catch (error) {
        console.error("Error fetching data:", error);
        throw error;
    }

};
